import { useTranslation } from 'react-i18next';

export default function HeroSection() {
  const { t } = useTranslation();

  return (
    <section className="relative w-full overflow-hidden">
      {/* Background image with overlay */}
      <div className="absolute inset-0 z-0">
        <img
          src="https://readdy.ai/api/search-image?query=Overhead%20view%20of%20colorful%20sneakers%20on%20pastel%20pink%20background%20with%20shopping%20bags%20and%20folded%20clothing%20scattered%20artistically%20bright%20clean%20ecommerce%20product%20photography&width=1600&height=900&seq=hero-bg-02&orientation=landscape"
          alt="AllChinaBuy Spreadsheet products"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/50" />
      </div>

      <div className="relative z-10 section-container py-20 md:py-32 lg:py-40">
        <div className="section-inner max-w-4xl">
          <h1 className="text-3xl md:text-5xl lg:text-6xl font-bold text-white leading-tight mb-6 font-heading">
            {t('hero_h1')}
          </h1>
          <p className="text-base md:text-lg text-white/90 leading-relaxed mb-8 max-w-2xl">
            {t('hero_subtitle')}
          </p>

          <div className="flex flex-col sm:flex-row gap-3 mb-6">
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center justify-center gap-2 px-6 py-3.5 rounded-md bg-primary-500 text-white font-semibold text-base hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              {t('hero_cta_primary')}
              <i className="ri-arrow-right-line" />
            </a>
            <button
              onClick={() => {
                const el = document.getElementById('categories');
                if (el) el.scrollIntoView({ behavior: 'smooth' });
              }}
              className="inline-flex items-center justify-center gap-2 px-6 py-3.5 rounded-md border-2 border-white/60 text-white font-semibold text-base hover:bg-white/10 transition-colors whitespace-nowrap cursor-pointer"
            >
              {t('hero_cta_secondary')}
            </button>
          </div>

          <p className="text-sm text-white/70 flex items-center gap-2 flex-wrap">
            <i className="ri-shield-check-line" />
            {t('hero_trust')}
          </p>
        </div>
      </div>
    </section>
  );
}